import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=45595a57&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=45595a57&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45595a57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45595a57')) {
      api.createRecord('45595a57', component.options)
    } else {
      api.reload('45595a57', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=45595a57&scoped=true", function () {
      api.rerender('45595a57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newLabelManagement/labelManagement/detail.vue"
export default component.exports